export default function Rust_Booleans() {
  return (
    <div>
      <h1>Rust_Booleans Component</h1>
      <p>This is the Rust_Booleans page.</p>
    </div>
  );
}
